import { useQuery } from 'react-query';
import { axios } from 'lib/axios';

export const getJobAdVersionsCount = ({ jobAdId }) => {
  return axios.get(`/api/job_ads/${jobAdId}/versions/count`);
};

export const useJobAdVersionsCount = (jobAdId, queryOptions) => {
  const { data, ...rest } = useQuery({
    queryKey: ['job-ad-versions-count', jobAdId],
    queryFn: () => getJobAdVersionsCount({ jobAdId }),
    select: ({ data }) => data.count,
    ...queryOptions,
  });
  return { data, ...rest };
};
